import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VAppBar,{staticStyle:{"color":"#FFFF"},attrs:{"color":"#3f4d63","elevation":"0"}},[_vm._v(" Monthly Activity Details - "+_vm._s(_vm.myMonth)+" ")]),_c(VCardText,[_c('UserLogElement',{key:_vm.myMonth,attrs:{"parentData":_vm.parentUser,"parentMonth":_vm.myMonth}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }